export default "__VITE_ASSET__CjpjhIVp__"